import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MobileApplicationDevComponent} from './mobile-application-dev.component';
import {HomepageModule} from '../homepage/homepage.module';
import {MobileApplicationIconsComponent} from './mobile-application-icons/mobile-application-icons.component';

@NgModule({
  imports: [
    CommonModule,
    HomepageModule,
  ],
  declarations: [MobileApplicationDevComponent, MobileApplicationIconsComponent],
  exports: [MobileApplicationDevComponent]
})
export class MobileApplicationDevModule {
}



// WEBPACK FOOTER //
// ./src/app/components/mobile-application-dev/mobile-application-dev.module.ts